import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { useReOS } from "../../domain/store";
import { marketplaceLabels } from "../../domain/labels";
import type { MarketplaceAccount } from "../../domain/types";
import { ConnectedChannelActivity } from "../../ConnectedChannelActivity";
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";

export function InventoryPhotoImport({ itemIDs, onClose }: { itemIDs: string[]; onClose: () => void }) {
  const store = useReOS();
  const [source, setSource] = useState<{ account: MarketplaceAccount; listingIDs: string[] }>();
  const accounts = store.marketplaceAccounts.filter((account) => account.connectionStatus === "connected" && ["ebay", "etsy"].includes(account.marketplace));
  const choices = accounts.flatMap((account) => {
    // One source listing per selected item; never import another item implicitly.
    const listings = itemIDs.flatMap((id) => {
      const listing = store.listingsFor(id).find((entry) => entry.marketplaceAccountID === account.id && entry.externalListingID);
      return listing ? [listing] : [];
    });
    return listings.length ? [{ account, listingIDs: listings.map((listing) => listing.id) }] : [];
  });
  if (source) return <div className="screen-content"><ConnectedChannelActivity key={source.account.id} account={source.account} initialTab="photos" initialPhotoListingIDs={source.listingIDs} onBack={onClose} /></div>;
  return <Dialog open onOpenChange={(open) => { if (!open) onClose(); }}><DialogContent presentation="compact">
    <DialogHeader><DialogTitle>Import listing photos</DialogTitle><DialogDescription>{itemIDs.length} {itemIDs.length === 1 ? "item" : "items"} selected. Choose a source, then review the photos.</DialogDescription></DialogHeader>
    <DialogBody><div className="inventory-photo-sources">
      {choices.map((choice) => <Button variant="secondary" key={choice.account.id} onClick={() => setSource(choice)}><span><strong>{marketplaceLabels[choice.account.marketplace]}</strong><small>{choice.listingIDs.length} of {itemIDs.length} selected items have linked listings</small></span><ArrowRight size={18} /></Button>)}
      {!choices.length && <p>These items have no linked listings on a connected eBay or Etsy account. Open an item to add photos from your device.</p>}
    </div></DialogBody>
  </DialogContent></Dialog>;
}
